// src/components/LearnerDashboard/CourseList.js
import React from "react";
import { Card, List, Row, Col, Typography, Progress, Button, Empty } from "antd";
import { BookOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { formatDateOnly } from "Common/Components/FormatDateTime";
import { useLocation, useNavigate } from "react-router-dom";
import AllTrainings from "PlatForms/OrgLMS/Hooks/useTrainingList";

const { Title, Text } = Typography;

const AllCourses = () => {
  const { enrolledTrainings, loading } = AllTrainings();
  const location = useLocation();
  const { darkMode = false } = location.state || {};
  const navigate = useNavigate();
  const thumbnail =
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80";

  const styles = {
    card: {
      borderRadius: 8,
      marginBottom: 16,
      backgroundColor: darkMode ? "#2a2a2a" : "#fff",
      borderColor: darkMode ? "#404040" : "#f0f0f0",
    },
    textColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    secondaryTextColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)",
    },
  };

  const isEmpty = !enrolledTrainings || enrolledTrainings.length === 0;

  return (
    <Card
      loading={loading}
      title={
        <span style={styles.textColor}>
          <BookOutlined style={{ marginRight: 8 }} /> My Courses
        </span>
      }
      style={{
        borderRadius: 12,
        marginBottom: 24,
        backgroundColor: darkMode ? "#1f1f1f" : "#fff",
        borderColor: darkMode ? "#303030" : "#f0f0f0",
      }}
      extra={
        <Button type="default" onClick={() => navigate(-1)}>
          Back
        </Button>
      }
    >
      {isEmpty ? (
        <Empty
          description={<span style={styles.secondaryTextColor}>Training Not Available</span>}
        />
      ) : (
        <List
          itemLayout="vertical"
          dataSource={enrolledTrainings}
          renderItem={(course) => (
            <List.Item style={{ padding: 0 }}>
              <Card hoverable style={styles.card}>
                <Row gutter={16} align="middle">
                  <Col xs={24} sm={6}>
                    <img
                      src={thumbnail}
                      alt={course.title}
                      style={{
                        width: "100%",
                        borderRadius: 8,
                        aspectRatio: "4/3",
                        objectFit: "cover",
                      }}
                    />
                  </Col>
                  <Col xs={24} sm={12}>
                    <Title level={5} style={{ marginBottom: 4, ...styles.textColor }}>
                      {course.title}
                    </Title>
                    <Text type="secondary" style={styles.secondaryTextColor}>
                      Instructor: {course.mentorName}
                    </Text>
                    <div style={{ marginTop: 8 }}>
                      <Progress
                        percent={course.progress}
                        strokeColor={darkMode ? "#1890ff" : "#40a9ff"}
                        showInfo={false}
                      />
                      <Text type="secondary" style={styles.secondaryTextColor}>
                        {course.progress}% complete
                      </Text>
                    </div>
                  </Col>
                  <Col xs={24} sm={6} style={{ textAlign: "right" }}>
                    <div>
                      <Text type="secondary" style={styles.secondaryTextColor}>
                        <ClockCircleOutlined />
                        &nbsp;
                        {`End Date: ${formatDateOnly(course.endDate)}`}
                      </Text>
                    </div>
                  </Col>
                </Row>
              </Card>
            </List.Item>
          )}
        />
      )}
    </Card>
  );
};

export default AllCourses;
